import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface Tomo {
  icon: string;
  title: string;
  situation: string;
  features: string[];
  result: string;
}
export function ProductShowcase() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const tomos: Tomo[] = [{
    icon: '📘',
    title: 'TOMO 1 — El Origen del Asombro (Lógica y Gnoseología)',
    situation: 'El primer encuentro con la Filosofía puede ser el más importante o el más aburrido de la vida de un alumno. Este tomo convierte el pensamiento abstracto en una herramienta de supervivencia digital.',
    features: ['Cómo enseñar a pensar en la era de la post-verdad', 'De los Presocráticos al análisis de fake news', 'Lógica aplicada a redes sociales', 'El método socrático para debunkear desinformación', 'Diseñado para alumnos que nunca tuvieron Filosofía antes'],
    result: 'Tus alumnos entran en modo "quiero saber más", no en modo "¿cuándo termina esto?"'
  }, {
    icon: '📗',
    title: 'TOMO 2 — El Animal Político (Poder y Ciudadanía)',
    situation: 'Enseñar política y poder sin que la clase se convierta en un debate de opiniones sin fundamento filosófico.',
    features: ['El contrato social explicado para el siglo XXI', 'De Maquiavelo y Hobbes al panóptico digital de Foucault e Instagram', 'Cómo funciona el poder y los derechos humanos de cuarta generación', 'La ciudadanía en un mundo globalizado', 'Sin referencias a coyunturas políticas locales que dividan al grupo'],
    result: 'Los alumnos entienden qué dijo cada filósofo, por qué lo dijo, y qué tiene que ver con el mundo en que viven hoy.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — El Espejo Humano (Antropología y Existencialismo)',
    situation: 'Conectar los grandes temas existenciales con las crisis propias de la adolescencia — sin que suene a terapia ni a clase de religión.',
    features: ['¿Qué nos hace humanos? El sentido de la vida según Sartre, Camus y la IA', 'Identidad, angustia y libertad aplicados al mundo de hoy', 'Textos adaptados con preguntas disparadoras para grupos de secundaria y bachillerato', 'Pensado para conectar con lo que tus alumnos ya están viviendo'],
    result: 'Clases donde los alumnos hablan de lo que les pasa de verdad, con lenguaje filosófico y sin darse cuenta.'
  }, {
    icon: '📕',
    title: 'TOMO 4 — Brújula Ética (Ética y Moral)',
    situation: 'Enseñar ética sin que parezca una clase de moral religiosa ni un listado de reglas vacías.',
    features: ['Dilemas morales que sí importan a los jóvenes de hoy', 'Bioética, ética ambiental y responsabilidad en el uso de tecnología', 'No les enseñamos qué pensar, sino cómo decidir frente a problemas reales de 2026', 'Actividades de reflexión personal que las inteligencias artificiales no pueden resolver por ellos'],
    result: 'Tus alumnos desarrollan criterio propio. Y vos podés evaluarlo de verdad.'
  }, {
    icon: '📓',
    title: 'TOMO 5 — La Ciencia en la Mira (Epistemología)',
    situation: 'Explicar cómo funciona el conocimiento sin perder a los alumnos en abstracciones que no aterrizan en nada concreto.',
    features: ['¿Cómo sabemos lo que sabemos?', 'El método científico frente a las pseudociencias', 'Análisis crítico sobre la verdad y el impacto de la ciencia en la vida cotidiana', 'Actividades para identificar fuentes confiables frente a la desinformación'],
    result: 'Los alumnos salen con herramientas reales para navegar un mundo saturado de información.'
  }, {
    icon: '📔',
    title: 'TOMO 6 — Mundos Posibles (Estética y Metafísica)',
    situation: 'Cerrar el año con un tomo que haga que los alumnos se pregunten cosas que nunca antes se habían preguntado.',
    features: ['¿Qué es la belleza hoy? Del arte clásico a la cultura de masas y la realidad virtual', 'Relectura del mito de la caverna aplicado al metaverso y las pantallas', 'El cierre perfecto para que el alumno entienda que la realidad es mucho más de lo que ve', 'Actividades de producción creativa con base filosófica sólida'],
    result: 'El tomo que hace que los alumnos le cuenten a alguien lo que aprendieron en clase.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-brand-dark" data-id="element-137">
      <div className="max-w-3xl mx-auto" data-id="element-138">
        <div className="text-center mb-8" data-id="element-139">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-text mb-4 leading-tight" data-id="element-140">
            KIT COMPLETO FILOSOFÍA LISTA
          </h2>
          <p className="text-base md:text-lg text-brand-text mb-6" data-id="element-141">
            6 tomos organizados por núcleos temáticos. 120+ secuencias
            didácticas completas. 4 bonos estratégicos.
          </p>
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-accent" data-id="element-142">
            📚 LOS 6 TOMOS MAESTROS — 360 PÁGINAS DE VALOR REAL
          </h3>
        </div>

        <div className="space-y-3" data-id="element-143">
          {tomos.map((tomo, index) => <div key={index} className="bg-brand-card rounded border border-black/10 overflow-hidden" data-id="element-144">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none bg-brand-card hover:bg-brand-cardAlt transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-145">
                <span className="font-bold text-base md:text-lg text-brand-text flex items-center gap-2" data-id="element-146">
                  <span className="text-xl" data-id="element-147">{tomo.icon}</span>
                  {tomo.title}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-148" /> : <ChevronDown className="w-5 h-5 text-brand-text/50 shrink-0" data-id="element-149" />}
              </button>

              <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[800px] pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-150">
                <div className="pt-4 border-t border-black/5" data-id="element-151">
                  <p className="text-sm font-bold text-brand-accent mb-2" data-id="element-152">
                    ¿Qué situación de aula resuelve?
                  </p>
                  <p className="text-sm text-brand-text mb-4 italic" data-id="element-153">
                    {tomo.situation}
                  </p>

                  <ul className="space-y-2 mb-4" data-id="element-154">
                    {tomo.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start text-sm text-brand-text" data-id="element-155">
                        <span className="text-brand-accent mr-2 mt-0.5" data-id="element-156">•</span>
                        <span data-id="element-157">{feature}</span>
                      </li>)}
                  </ul>

                  <div className="bg-brand-cardAlt p-3 rounded border border-black/5" data-id="element-158">
                    <p className="text-sm font-bold text-brand-success" data-id="element-159">
                      ✅ Resultado:{' '}
                      <span className="text-brand-text font-normal" data-id="element-160">
                        {tomo.result}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}